import { connect } from 'react-redux'
import cycleCountActions from 'actions/cycleCounts'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import Component from 'components/CycleCounts/Create'

const mapDispatchToProps = (dispatch, props) => ({
  getSettings: (params) => dispatch(cycleCountActions.getSettings(params)),
  createItem: (params) => dispatch(cycleCountActions.createItem(params)),
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getItems({ ...params, locationVendingTypes: ['NonVending'] })),
  getItemCount: (params) => dispatch(locationActions.getItemCount(params)),
})

export default connect(null, mapDispatchToProps)(Component)
